import React from 'react';
import {
  Row, Col, Dropdown, MenuItem,
} from 'react-bootstrap';


function ButtonWithConfirmation({
  className,
  children,
  confirmationMessage,
  onOption1Select,
  dropdownClassname,
  toggleButtonClassName,
  onOption2Select,
  option1Label,
  option2Label,
  pullRight,
  dropup,
  disabled,
  id,
}) {
  return (
    <span id={id} className={className}>
      <Dropdown
        disabled={disabled}
        pullRight={pullRight}
        className={dropdownClassname}
        dropup={dropup}
        id={confirmationMessage}
      >
        <Dropdown.Toggle noCaret className={toggleButtonClassName}>
          {children}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <MenuItem header>
            <div className="bold confirm-dropdown-header">
              {confirmationMessage}
            </div>
          </MenuItem>
          <MenuItem key="option1" onSelect={onOption1Select}>
            {option1Label}
          </MenuItem>
          <MenuItem key="option2" onSelect={onOption2Select}>
            {option2Label}
          </MenuItem>
        </Dropdown.Menu>
      </Dropdown>
    </span>
  );
}

export default ButtonWithConfirmation;
